import {
	Container,
	ContainerGutter,
	CTA,
	styled,
	Text,
	TextAlignment,
	ThemeProvider,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { useHuchaPopup } from '../../../hooks/use-hucha-popup';
import { HuchaValues } from '../../../models/hucha-values';
import { HuchaLogo } from '../../../asserts/hucha-logo';

const MainContainer = styled(Container)`
	padding: 0px;
	align-content: center;
	height: 100%;
	align-content: center;

	/* Desktop */
	@media (min-width: 1280px) {
		padding-right: var(--size-dynamic0100);
	}
`;

const AlignedContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: fit-content;
	gap: 20px;
`;

export const RenovadoresBonusCardC1: React.FC<{
	huchaValues: HuchaValues | null;
}> = ({ huchaValues }) => {
	const { handlePopupOpen } = useHuchaPopup(huchaValues);
	return (
		<MainContainer gutter={ContainerGutter.static300} wrap="always" data-testid="c1-container">
			<HuchaLogo />

			<AlignedContainer>
				<Text
					appearance={TokenTextAppearance.headline100}
					color={TokenTextColor.inverted}
					textAlign={TextAlignment.left}
					bold
				>
					{'Cada mes, acumulas 10€ para tu próximo Volkswagen'}
				</Text>

				<ThemeProvider theme="inverted">
					<CTA tag="button" emphasis="primary" onClick={handlePopupOpen}>
						Aprovéchalos
					</CTA>
				</ThemeProvider>
			</AlignedContainer>
		</MainContainer>
	);
};
